import { ConfigService, TrackerService } from '../services';
import { Storage } from '../constants';
import { Routes } from '../Routes';
import { ChatStore, ConfigurationStore, CreditsStore, FamilyRegistrationStore, NotificationStore, ParentStore, SitterReviewStore, UserStore, VerificationStore } from '../models';
import { CompanyEmployeeStore } from '../models/CompanyEmployeeStore';
import { FacebookSdk } from 'us-react-components/dist/utils/FacebookSdk';

declare global {
  interface Window {
    google?: {
      accounts?: {
        id?: {
          initialize: (opts: unknown) => void;
          renderButton: (el: HTMLElement | null, opts: unknown) => void;
        };
      };
    };
  }
}

export class Environment {
  services: {
    config: ConfigService;
    tracker: TrackerService;
  };

  stores: {
    chat: ChatStore;
    companyEmployees: CompanyEmployeeStore;
    configuration: ConfigurationStore;
    credits: CreditsStore;
    familyRegistration: FamilyRegistrationStore;
    notifications: NotificationStore;
    parent: ParentStore;
    sitterReview: SitterReviewStore;
    user: UserStore;
    verification: VerificationStore;
  };

  constructor() {
    if (!localStorage.getItem(Storage.US_USER_AUTH_TOKEN) || !localStorage.getItem(Storage.US_USER_OBJECT)) {
      window.location.href = `${Routes.login}?redirectTo=${encodeURIComponent(window.location.pathname)}`;
    }

    const config = new ConfigService();
    const chat = new ChatStore();
    const configuration = new ConfigurationStore();
    const user = new UserStore();
    const notifications = new NotificationStore(user);
    const parent = new ParentStore();
    const credits = new CreditsStore(user);
    const verification = new VerificationStore(user);
    const companyEmployees = new CompanyEmployeeStore(user);
    const familyRegistration = new FamilyRegistrationStore(user, parent);
    const sitterReview = new SitterReviewStore();

    this.stores = {
      chat,
      companyEmployees,
      configuration,
      credits,
      familyRegistration,
      notifications,
      parent,
      sitterReview,
      user,
      verification,
    };

    // order matters, these service depend on stores
    const tracker = new TrackerService(config, this);

    this.services = {
      config,
      tracker,
    };
    FacebookSdk.preload();
  }

  async setup(): Promise<void> {
    await this.stores.user.refreshUser();
    await this.stores.verification.getUserVerification();
    await this.stores.verification.getStripeVerification();

    if (this.stores.user.user?.parent) {
      await this.stores.parent.refreshParent();
    }
  }
}
